export { default } from './Card';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Card/index.js
// module id = 813
// module chunks = 2